import React from 'react';
import MuiDialog from '@mui/material/Dialog';

const DialogDraggable = (props) => <MuiDialog {...props} />;

export default DialogDraggable;
